/* Editor-content enhancement for .hub-prose containers.
 *
 * Three passes, all ADDITIVE: they set classes, attributes and at most a
 * heading's own text. No markup is rebuilt and no element is moved, so a pass
 * that finds nothing to do leaves the body exactly as the editor wrote it, and
 * with JavaScript off every page still reads correctly.
 *
 *   1. captions   — alt text rendered as a visible caption beneath the image
 *   2. standfirst — the opening paragraph set larger        (opt in)
 *   3. steps      — numbered headings turned into step cards (opt in)
 *
 * Passes 2 and 3 are opt-in per container, via data-hub-standfirst and
 * data-hub-steps, because they suit guides and not every prose page.
 */
(function () {
  'use strict';

  /* ---- 1. captions ------------------------------------------------------
   * CSS cannot do this: alt is an attribute of a replaced element, so ::after
   * never generates for it. The editor convention (see ASADO-HUB-BRIEF.md) is
   * that alt text doubles as the caption, which keeps one field doing both jobs
   * for Katrina rather than asking for a caption she would have to remember.
   *
   * An image with no alt gets no caption. Decorative images therefore opt out
   * by having an empty alt, which is also the correct accessibility behaviour.
   */
  function caption(root) {
    // Set by the section. When the alt is just the article title — which is
    // what our own image_tag calls pass — a caption repeating the headline is
    // noise, so it is skipped.
    var title = (root.getAttribute('data-hub-title') || '').trim().toLowerCase();

    root.querySelectorAll('img[alt]:not([data-hub-captioned])').forEach(function (img) {
      img.setAttribute('data-hub-captioned', '1');
      var text = (img.getAttribute('alt') || '').trim();
      if (!text) return;
      if (title && text.toLowerCase() === title) return;
      // Shopify sometimes emits the filename as alt; a caption of
      // "IMG_4032.jpeg" is worse than none.
      if (/^[\w -]+\.(jpe?g|png|gif|webp|heic)$/i.test(text)) return;
      var cap = document.createElement('span');
      cap.className = 'hub-prose__caption';
      cap.textContent = text;
      // After the image, or after its wrapping link/figure if it has one.
      var anchor = img.closest('a, figure') || img;
      anchor.parentNode.insertBefore(cap, anchor.nextSibling);
    });
  }

  /* ---- 2. standfirst ----------------------------------------------------
   * Only when the body OPENS with a paragraph. A body that opens with a heading
   * has no opening paragraph to promote — the first one sits under that heading
   * and belongs to it, so setting it larger would read as a caption for the
   * heading rather than an introduction to the page.
   */
  function standfirst(root) {
    if (!root.hasAttribute('data-hub-standfirst')) return;
    if (root.querySelector('.hub-prose__standfirst')) return;

    var first = null;
    for (var i = 0; i < root.children.length; i++) {
      var el = root.children[i];
      // Rich text and pasted HTML both leave empty paragraphs behind.
      if (el.tagName === 'P' && !el.textContent.trim()) continue;
      first = el;
      break;
    }
    if (first && first.tagName === 'P') first.classList.add('hub-prose__standfirst');
  }

  /* ---- 3. steps ---------------------------------------------------------
   * A heading the editor numbered by hand becomes a step card. Both forms the
   * guides use are recognised, at any heading level:
   *
   *   "1. Start with the Setup"      "Step 1: Light the fire"
   *
   * A separator after the digits is required, so "3 Ways to Light a Fire" and
   * "2026 in review" are left alone. Verified against the pizza guide, where
   * exactly the eight numbered headings match and "James' Top Tip",
   * "PIZZA PEEL" and the rest do not.
   *
   * The numeral itself is drawn in CSS from data-step. All this does is set the
   * attribute and remove the prefix the editor typed, so nothing is duplicated.
   */
  // (?!\.\d) stops a decimal being read as a step number: "1.5 hours of resting"
  // would otherwise become step 1 labelled "5 hours of resting".
  var STEP = /^\s*(?:step\s+)?(\d{1,2})(?!\.\d)\s*[.:)]\s*(.+)$/i;

  function steps(root) {
    if (!root.hasAttribute('data-hub-steps')) return;

    root.querySelectorAll('h2, h3, h4, h5, h6').forEach(function (h) {
      if (h.hasAttribute('data-step')) return;
      var m = STEP.exec(h.textContent || '');
      if (!m) return;
      h.setAttribute('data-step', m[1]);
      h.classList.add('hub-prose__step');
      // Replace only the text, and only on a heading whose content is text —
      // a heading carrying a link or an image is left intact.
      if (h.children.length === 0) h.textContent = m[2].trim();
    });
  }

  function boot() {
    document.querySelectorAll('.hub-prose').forEach(function (root) {
      caption(root);
      standfirst(root);
      steps(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();
